import { categories } from "@/mocks/categories";
import ScrollReveal from "@/components/base/ScrollReveal";

export default function Categories() {
  return (
    <section id="categorias" className="relative w-full py-20 md:py-28 bg-organic-cool overflow-hidden">
      <div className="relative w-full px-4 sm:px-6 md:px-10 lg:px-16 max-w-7xl mx-auto">
        <ScrollReveal className="text-center mb-14">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600 mb-4">
            Nossas Especialidades
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
            Explore nossas{" "}
            <span className="text-primary-600">categorias</span>
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-base md:text-lg">
            De sanduíches naturais à soluções completas para eventos, temos o que você precisa.
          </p>
        </ScrollReveal>

        <ScrollReveal direction="up" delay={0.15} staggerChildren staggerDelay={0.1}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {categories.map((cat) => (
              <a
                key={cat.id}
                href={cat.href}
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector(cat.href);
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                }}
                className="group relative block rounded-2xl overflow-hidden bg-background-50 border border-background-200/30 card-glow transition-all duration-500 hover:-translate-y-2 cursor-pointer"
              >
                <div className="relative h-52 sm:h-56 img-zoom">
                  <img
                    src={cat.image}
                    alt={cat.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <span className="inline-block px-2.5 py-1 rounded-md bg-primary-500/90 text-background-50 text-[10px] font-semibold uppercase tracking-wider backdrop-blur-sm mb-2">
                      {cat.subtitle}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-1.5 group-hover:text-primary-600 transition-colors">
                    {cat.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    {cat.description}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                    {cat.cta}
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                  </span>
                </div>
              </a>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}